import { type MouseEvent, useCallback } from 'react';
import { VisuallyHidden } from '@ev-tech/ui-core-components/VisuallyHidden';

import { useSearchResultCardContext } from './SearchResultCardProvider';

import styles from './SearchResultCardArticleWrapper.module.css';

export const SearchResultCardLink = () => {
  const { isContextMenuLinkOverlayActive, link, linkComponent: Link, linkRef, onClickPropertyCardLink } = useSearchResultCardContext();

  const handlePropertyCardLinkClick = useCallback(
    (e: MouseEvent<HTMLAnchorElement>) => {
      e.stopPropagation();
      onClickPropertyCardLink(e);
    },
    [onClickPropertyCardLink],
  );

  return (
    <div className={styles.linkContainer} data-context-menu-link-overlay-active={isContextMenuLinkOverlayActive}>
      <Link onClick={handlePropertyCardLinkClick} href={link.href}>
        <VisuallyHidden>
          <span ref={linkRef}>{link.label}</span>
        </VisuallyHidden>
      </Link>
    </div>
  );
};
